import React from "react";

const LogoIcon = (props) => (
  <img alt="Logo" src="/static/icon_transparent.svg" {...props} />
);

export default LogoIcon;
